import { Yup } from "lib/yup/extendYup";

export const fbcValidationSchema = Yup.object().shape({
  wbcRange: Yup.object()
    .range({ min: 0, max: 1000, message: "WBC normal range values should be between 0 and 1000" })
    .required("WBC normal range is required"),
  haemoglobinRangeFemale: Yup.object()
    .range({ min: 0, max: 1000, message: "Normal Haemoglobin range for Females values should be between 0 and 1000" })
    .required("Normal Haemoglobin range for Females is required"),
  haemoglobinRangeMale: Yup.object()
    .range({ min: 0, max: 1000, message: "Normal Haemoglobin range for Males values should be between 0 and 1000" })
    .required("Normal Haemoglobin range for Males is required"),
  neutrophilRange: Yup.object()
    .range({ min: 0, max: 1000, message: "Neutrophils normal range values should be between 0 and 1000" })
    .required("Neutrophils normal range is required"),
  plateletRange: Yup.object()
    .range({ min: 0, max: 1000, message: "Platelet normal range values should be between 0 and 1000" })
    .required("Platelet normal range is required"),
  confirmatoryThreshold: Yup.number().min(0).max(1000).required("Neutrophils threshold is required"),
});

export const wbcValidationSchema = Yup.object().shape({
  wbcRange: Yup.object()
    .range({ min: 0, max: 1000, message: "WBC normal range values should be between 0 and 1000" })
    .required("WBC normal range is required"),
  granulocyteRange: Yup.object()
    .range({ min: 0, max: 1000, message: "Granulocyte normal range values should be between 0 and 1000" })
    .required("Granulocyte normal range is required"),
  confirmatoryThreshold: Yup.number().min(0).max(1000).required("Granulocytes threshold is required"),
});

// Backwards-compatible alias for callers still importing the previous name.
export const hospitalConfigValidationSchema = fbcValidationSchema;
